import React, { useEffect, useRef, useState } from "react";
import "../css/CuDropdown.css";
import { IoClose } from "react-icons/io5";
import CuSpinner from "./CuSpinner";
import { capitalizeFirstWord } from "../../new_appointment/_helper/utils.js/utils";

const CuDropdown = ({
  options,
  onChange,
  searchable,
  placeholder = "",
  onSearch,
  capitalFirstLetter,
  capitalize,
  allowAdditions,
  additionLabel = "Add",
  onAddItem,
  clearable,
  onClear,
  required,
  value,
  id,
  disabled = false,
  style,
  loading = false,
  clearSearch,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedItem, setSelectedItem] = useState(0);
  const optionsRef = useRef([]);
  const optionsContainerRef = useRef(null);

  useEffect(() => {
    if (value) {
      const selectedOptionText = options?.find((opt) => opt?.value === value);
      if (selectedOptionText) {
        setSelectedOption(selectedOptionText?.text);
      }
    } else {
      setSelectedOption(searchable ? selectedOption : "");
    }
    if (options) {
      setFilteredOptions(options);
    }
  }, [value, options]);

  const handleIsOpen = () => {
    if (disabled === false) {
      setIsOpen((prev) => !prev);
    }
  };

  const handleOptionClick = (item) => {
    const selectedOptionText = options?.find((opt) => opt?.value === item);
    if (selectedOptionText) {
      setSelectedOption(selectedOptionText?.text);
      if (onChange) {
        onChange(item);
      }
    }
    setIsOpen(false);
    if (clearSearch) {
      setSelectedOption("");
    }
  };

  const getSearchResult = (match) => {
    const filteredOptions = options.filter((option) =>
      option?.text?.toLowerCase().includes(match.toLowerCase())
    );
    setFilteredOptions(filteredOptions);
  };

  const handleSearch = (e) => {
    let searchValue = capitalFirstLetter
      ? capitalizeFirstWord(e.target.value)
      : e.target.value;
    // let searchValue = e.target.value;
    searchValue = capitalize ? e.target.value.toUpperCase() : searchValue;

    if (onSearch) {
      onSearch(searchValue);
    }
    setSelectedOption(searchValue);
    getSearchResult(searchValue);
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const handleAddition = () => {
    // //(selectedOption, 'sdhsaaa')
    if (onAddItem) {
      onAddItem(selectedOption);
    }
    setSelectedOption("");
    setIsOpen(false);
  };

  const handleClear = () => {
    if (disabled) {
      return;
    }
    if (onClear) {
      onClear(selectedOption);
    }
    setSelectedOption(placeholder);
  };

  // //(selectedOption, filteredOptions, 'dasjldskl')
  const handleKeyEvents = (e) => {
    if (e.key === "ArrowDown" && selectedItem < filteredOptions.length - 1) {
      e.preventDefault();
      setSelectedItem((prev) => prev + 1);
      const selectedOptionElement = optionsRef.current[selectedItem + 1];
      if (selectedOptionElement) {
        const containerRect =
          optionsContainerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.bottom > containerRect.bottom) {
          optionsContainerRef.current.scrollTop +=
            optionRect.bottom - containerRect.bottom;
        }
      }
    } else if (e.key === "ArrowUp" && selectedItem > 0) {
      e.preventDefault();
      setSelectedItem((prev) => prev - 1);
      const selectedOptionElement = optionsRef.current[selectedItem - 1];
      if (selectedOptionElement) {
        const containerRect =
          optionsContainerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.top < containerRect.top) {
          optionsContainerRef.current.scrollTop -=
            containerRect.top - optionRect.top;
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      optionsRef.current[selectedItem].click();
      setSelectedItem(0);
    }
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        optionsContainerRef.current &&
        !optionsContainerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <div className="cudropdown-input">
      <input
        type="text"
        onClick={handleIsOpen}
        // onBlur={() => setIsOpen(false)}
        value={selectedOption}
        id={id}
        onChange={handleSearch}
        readOnly={searchable ? false : true}
        onKeyDown={handleKeyEvents}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        style={style}
        className="text-sm md:text-sm xl:text-sm 2xl:text-lg"
      />
      <span className="cudropdown-clearable">
        {clearable && selectedOption && !loading ? (
          <IoClose onClick={handleClear} />
        ) : (
          <>
            {id !== "consultation" && !loading && (
              <img
                onClick={handleIsOpen}
                src={
                  "https://cufront-assets.s3.amazonaws.com/icons+/mdi_menu-down.png"
                }
              />
            )}
            {loading && <CuSpinner />}
          </>
        )}
      </span>
      {isOpen && (
        <div className="cudropdown-options-menu" ref={optionsContainerRef}>
          {filteredOptions?.map((opt, index) => (
            <div
              ref={(el) => (optionsRef.current[index] = el)}
              className={`cudropdown-options-menu-item ${
                selectedItem === index
                  ? "cudropdown-options-menu-item-active"
                  : ""
              }`}
              key={opt?.key}
              onClick={() => handleOptionClick(opt?.value)}
            >
              {opt?.text}
            </div>
          ))}
          {!allowAdditions &&
            filteredOptions?.length === 0 &&
            selectedOption?.length > 0 && (
              <div className="cudropdown-nodatafound">No results found</div>
            )}
          {allowAdditions &&
            !loading &&
            filteredOptions?.length === 0 &&
            selectedOption?.length > 0 && (
              <div
                ref={(el) => (optionsRef.current[0] = el)}
                className={`cudropdown-options-menu-item ${
                  selectedItem === 0
                    ? "cudropdown-options-menu-item-active"
                    : ""
                }`}
                onClick={handleAddition}
              >
                {`${additionLabel} `}
                <span className="cudropdown-addtion-text">
                  {selectedOption}
                </span>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default CuDropdown;
